<script setup lang="ts">
import { useRouter } from 'vue-router'
import FormResetPassword from './form-reset-password.vue'
import { ModalCollection } from '~/constants'
import ModalAuth from '~/components/common/auth/modal-auth.vue'

const router = useRouter()
const handleCloseModal = async (): Promise<void> => {
  await router.push('/')
}
</script>
<template>
  <ModalAuth
    :modalId="ModalCollection.RESET_PASSWORD"
    :isClickBackdropClose="false"
    modalWidthClass="reset-password-modal"
    @handleCloseModal="handleCloseModal"
  >
    <div class="auth-form">
      <FormResetPassword />
    </div>
  </ModalAuth>
</template>
<style lang="scss" scoped src="~scssAsset/desktop/auth/modal-auth.scss"></style>
